import { render } from "./HighlightButton.vue?vue&type=template&id=f97ee982"
import script from "./HighlightButton.vue?vue&type=script&lang=js"
export * from "./HighlightButton.vue?vue&type=script&lang=js"

import "./HighlightButton.vue?vue&type=style&index=0&id=f97ee982&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__